import {Box} from "@mui/material";
import {useMemo} from "react";

export const OrderItem = ({data}) => {
    const fetchPrice = useMemo(() => {
        const unitPrice = data?.unitPrice?.amount
        const originalUnitPrice = data?.originalUnitPrice?.amount
        const totalPrice = data?.totalPrice?.amount / data?.quantity
        const price = (originalUnitPrice || unitPrice || totalPrice)

        return `${price}` || "-"
    },[])

    return(
        <Box sx={{display: "flex", alignItems: "flex-start", gap: "6px", padding: "20px 0px"}} className="order-item">
            <Box sx={{width: "25%"}}>
                <img src={data?.imageUrl} alt={data?.name} className="order-item-img" />
            </Box>
            <Box sx={{width: "75%"}}>
                <Box  as={"p"} sx={{fontFamily: "FustatSemiBold", fontSize: "14px",margin: "0px 0px 6px"}}>
                    {data?.name}
                </Box>
                <Box>
                    <Box  as={"p"} sx={styles.infoText}>
                        SKU {data?.productId}
                    </Box>
                    <Box  as={"p"} sx={styles.infoText}>
                       Item Price {fetchPrice}
                    </Box>
                    <Box  as={"p"} sx={styles.infoText}>
                        Quantity {data?.quantity || "-"}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

const styles = {
    infoText: {
        fontFamily: "FustatSemiBold",
        color: "#595959",
        fontSize: "12px",
        margin: "0px"
    }
}